var render, staticRenderFns
import script from "./frozen_detail_table.vue?vue&type=script&lang=js&"
export * from "./frozen_detail_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c2f1f8')) {
      api.createRecord('44c2f1f8', component.options)
    } else {
      api.reload('44c2f1f8', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_goods/form/components/frozen_detail_table.vue"
export default component.exports